import { useMutation } from "react-query"
import { DataBaseService } from "../services/DatabaseService"
import { ErrorResponse } from "../types/ErrorResponse"
import { Referral } from "../types/Referral"
import { LanguageOption } from "../types/LanguageOption"
import i18n from "../i18n"

type Variables = {
  file: File
  province: string
}

export function usePostValidateCsv() {
  const lang = i18n.resolvedLanguage as LanguageOption
  const { mutate, isLoading, isSuccess, isError } = useMutation<
    { message: string },
    ErrorResponse,
    Variables
  >(["validateCsv"], ({ file, province }) =>
    DataBaseService.validateCsv(file, province, lang),
  )
  return { validateCsv: mutate, isLoading, isSuccess, isError }
}

export function usePostMapCsv() {
  const lang = i18n.resolvedLanguage as LanguageOption
  const { mutate, isLoading, isSuccess, isError } = useMutation<
    Referral,
    ErrorResponse,
    Variables
  >(["mapCsv"], ({ file, province }) =>
    DataBaseService.mapCsv(file, province, lang),
  )

  return { mapCsv: mutate, isLoading, isSuccess, isError }
}
